import { render, staticRenderFns } from "./_subId.vue?vue&type=template&id=8ad231fa&scoped=true"
import script from "./_subId.vue?vue&type=script&lang=js"
export * from "./_subId.vue?vue&type=script&lang=js"
import style0 from "./_subId.vue?vue&type=style&index=0&id=8ad231fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad231fa",
  null
  
)

export default component.exports